import { Observable } from "rxjs";
import { BleClient, ScanResult } from "@capacitor-community/bluetooth-le";
import { resetNotificationStreams } from "@/features/ble/utils/getDeviceNotificationsStream.tsx";
import { resetSequences } from "@/features/ble/utils/sendCommand.ts";

/**
 * An observable that emits scan results
 * and completes after the specified duration.
 * @param scanDurationMs
 */
export const requestLEScan = (scanDurationMs = 4000) =>
  new Observable<ScanResult>((subscriber) => {
    const scan = async () => {
      try {
        await BleClient.initialize({ androidNeverForLocation: true });
        await Promise.all(
          (
            await BleClient.getConnectedDevices([])
          ).map((device) => BleClient.disconnect(device.deviceId))
        );
        resetNotificationStreams();
        resetSequences();
        await BleClient.requestLEScan(
          {
            namePrefix: "Klereo",
            services: [],
            allowDuplicates: false,
          },
          (result) => {
            console.log("new result", result);
            subscriber.next(result);
          }
        );
        setTimeout(async () => {
          await BleClient.stopLEScan();
          subscriber.complete();
        }, scanDurationMs);
      } catch (error) {
        subscriber.error(error);
      }
    };

    scan();
  });
